import { FC, useRef, useState } from 'react'
import { Stack, useRadio } from '@chakra-ui/react'
import { Box, Text } from '../index'
import { RadioButtonProps } from './interfaces'
import theme from '../../styles'
import { RadioButton } from './radio-button'
import { useTranslation } from 'react-i18next'
import { getLocale } from '../../i18n/locale'

export const MainPillWithAdditionalButtonRadioButton: FC<RadioButtonProps> = (props) => {
  const { getInputProps, getCheckboxProps } = useRadio(props)
  const inputRef = useRef<HTMLInputElement>(null)
  const { t } = useTranslation()
  const [showCopied, setShowCopied] = useState(false)

  const handleFocus = () => {
    if (inputRef.current) {
      inputRef.current.focus()
    }
  }

  const copyLinkToClipboard = async () => {
    const linkcontest =
      getLocale() === 'fr'
        ? 'https://www.planhub.ca/question/?locale=fr&scenarioType=decision-review-contest&referrer=http%3A%2F%2Fwww.planhub.ca%2Ffr%2Fawards%2F2026%2F'
        : 'https://www.planhub.ca/question/?locale=en&scenarioType=decision-review-contest&referrer=http%3A%2F%2Fwww.planhub.ca%2Fawards%2F2026%2F'

    try {
      if (navigator?.clipboard?.writeText) {
        try {
          await navigator.clipboard.writeText(linkcontest)
          setShowCopied(true)
          return
        } catch (err) {
          console.error('Clipboard API failed:', err)
        }
      }

      const textarea = document.createElement('textarea')
      textarea.value = linkcontest
      textarea.setAttribute('readonly', '')
      textarea.style.position = 'absolute'
      textarea.style.left = '-9999px'
      textarea.style.top = '0'
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
      setShowCopied(true)
    } catch (err) {
      console.error('Failed to copy referral code:', err)
    }
  }

  return (
    <Stack>
      <Box as="label" cursor="pointer" data-testid={`pill-${props.value}`}>
        <Box
          tabIndex={0}
          layerStyle={theme.LayerStyles.MAIN_PILL_WITH_ADDITIONAL_BUTTON}
          aria-label="test"
          _focus={{
            borderColor: 'brand',
            boxShadow: '0 0 0 2px #5bce4c',
            transform: 'scale(1.05)',
            transition: 'all 0.3s',
          }}
          backgroundColor={'brand'}
          display="flex"
          justifyContent="center"
          alignItems="center"
          textColor={'white'}
          fontWeight={'900'}
          onClick={copyLinkToClipboard}
        >
          {showCopied ? (
            <Text color="white" mb={2} fontWeight="bold">
              {t('link-copied-to-clipboard') as string}
            </Text>
          ) : (
            <>
              <Text mr={2} display="flex" alignItems="center">
                <svg width="18" height="19" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect
                    x="4.40625"
                    y="5.375"
                    width="9.73189"
                    height="9.65"
                    rx="0.625"
                    fill="#6BCE4C"
                    stroke="white"
                    strokeWidth="0.75"
                  />
                  <rect
                    x="0.375"
                    y="0.375"
                    width="9.73189"
                    height="9.65"
                    rx="0.625"
                    fill="#6BCE4C"
                    stroke="white"
                    strokeWidth="0.75"
                  />
                </svg>
              </Text>
              <Text>{t('copy-share-contest') as string}</Text>
            </>
          )}
        </Box>
      </Box>
      <Box as="label" cursor="pointer" data-testid={`pill-${props.value}`}>
        <Box
          {...getCheckboxProps()}
          tabIndex={0}
          onFocus={handleFocus}
          layerStyle={theme.LayerStyles.MAIN_PILL_WITH_ADDITIONAL_BUTTON}
          aria-label={`button-${props.label}`}
          _focus={{
            borderColor: 'brand',
            boxShadow: '0 0 0 2px #364f33ff',
            transform: 'scale(1.05)',
            transition: 'all 0.3s',
          }}
          display="flex"
          justifyContent="center"
          alignItems="center"
          textColor={'brand'}
        >
          <RadioButton {...getInputProps()} ref={inputRef} />
          <Text>{props.label}</Text>
        </Box>
      </Box>
    </Stack>
  )
}
